"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _recompose = require("recompose");
var _ChartLegend = _interopRequireDefault(require("../components/ChartLegend"));
var _excluded = ["series", "showLegend", "colors", "disableLegendOnClick", "disableLegendOnHover"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * Higher Order Component which wraps a Chart with a Legend component, and also
 * passes `activeSeries` and `focusedSeries` to the wrapped component.
 */
var withLegend = function withLegend(ChartComponent) {
  var _WrappedComponent;
  return _WrappedComponent = /*#__PURE__*/function (_React$PureComponent) {
    (0, _inherits2["default"])(WrappedComponent, _React$PureComponent);
    function WrappedComponent(props) {
      var _this;
      (0, _classCallCheck2["default"])(this, WrappedComponent);
      _this = _callSuper(this, WrappedComponent, [props]);
      _this.state = {
        activeSeriesIndexSet: WrappedComponent.getIntialActiveSeriesIndexSet(_this.props.series),
        focusedSeriesIndex: undefined
      };
      _this.focusesSeriesIndexChange = _this.focusesSeriesIndexChange.bind((0, _assertThisInitialized2["default"])(_this));
      _this.updateActiveSeries = _this.updateActiveSeries.bind((0, _assertThisInitialized2["default"])(_this));
      return _this;
    }

    // eslint-disable-next-line camelcase
    (0, _createClass2["default"])(WrappedComponent, [{
      key: "UNSAFE_componentWillReceiveProps",
      value: function UNSAFE_componentWillReceiveProps(nextProps) {
        /** If the number of series changes we should reset the 'active' series state */
        if (this.props.series.length !== nextProps.series.length) {
          this.setState({
            activeSeriesIndexSet: WrappedComponent.getIntialActiveSeriesIndexSet(nextProps.series)
          });
        }
      }
    }, {
      key: "focusesSeriesIndexChange",
      value: function focusesSeriesIndexChange(focusedSeriesIndex) {
        this.setState({
          focusedSeriesIndex: focusedSeriesIndex
        });
      }
    }, {
      key: "updateActiveSeries",
      value: function updateActiveSeries(seriesIndex) {
        var series = this.props.series;
        var activeSeriesIndexSet = this.state.activeSeriesIndexSet;

        // If all series are active, then make active only one that was clicked
        if (activeSeriesIndexSet.size === series.length) {
          this.setState({
            activeSeriesIndexSet: new Set().add(seriesIndex)
          });
          return;
        }
        var updatedActiveSeriesIndexSet = new Set(activeSeriesIndexSet);
        if (updatedActiveSeriesIndexSet.has(seriesIndex)) {
          updatedActiveSeriesIndexSet["delete"](seriesIndex);
          // If user deselect the only active series, then make all series active back
          if (!updatedActiveSeriesIndexSet.size) {
            updatedActiveSeriesIndexSet = WrappedComponent.getIntialActiveSeriesIndexSet(series);
          }
        } else {
          updatedActiveSeriesIndexSet.add(seriesIndex);
        }
        this.setState({
          activeSeriesIndexSet: updatedActiveSeriesIndexSet
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
          series = _this$props.series,
          showLegend = _this$props.showLegend,
          colors = _this$props.colors,
          disableLegendOnClick = _this$props.disableLegendOnClick,
          disableLegendOnHover = _this$props.disableLegendOnHover,
          props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
        var _this$state = this.state,
          activeSeriesIndexSet = _this$state.activeSeriesIndexSet,
          focusedSeriesIndex = _this$state.focusedSeriesIndex;
        return /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            display: 'flex',
            height: '100%',
            flexDirection: 'column',
            width: '100%'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            flex: 1
          }
        }, /*#__PURE__*/_react["default"].createElement(ChartComponent, (0, _extends2["default"])({}, props, {
          // TODO make it correctly....
          activeSeriesIndexSet: activeSeriesIndexSet,
          focusedSeries: focusedSeriesIndex,
          series: series,
          colors: colors
        }))), /*#__PURE__*/_react["default"].createElement("div", null, showLegend ? /*#__PURE__*/_react["default"].createElement(_ChartLegend["default"], {
          activeSeriesIndexSet: activeSeriesIndexSet,
          focusedSeriesIndex: focusedSeriesIndex,
          colors: series.map(function (s, index) {
            return s.color || colors[index];
          }),
          labels: series.map(function (s, index) {
            return s.label || "Series #".concat(index);
          }),
          onLegendItemClick: this.updateActiveSeries,
          onHoveredLegendItemIndexChange: this.focusesSeriesIndexChange,
          disableLegendOnClick: disableLegendOnClick,
          disableLegendOnHover: disableLegendOnHover
        }) : null));
      }
    }], [{
      key: "getIntialActiveSeriesIndexSet",
      value: function getIntialActiveSeriesIndexSet(series) {
        // assume that all series are active
        return new Set(series.map(function (_, index) {
          return index;
        }));
      }
    }]);
    return WrappedComponent;
  }(_react["default"].PureComponent), (0, _defineProperty2["default"])(_WrappedComponent, "displayName", "withLegend(".concat((0, _recompose.getDisplayName)(ChartComponent), ")")), _WrappedComponent;
};
var _default = exports["default"] = withLegend;
//# sourceMappingURL=withLegend.js.map